@if (breakPointObserve$ | async) {
  @if (!isMobile && !isTablet) {
    <app-multi-select
      [options]="selectColumns"
      (choose)="onChoose($event)"
      [buttonWidth]="0"
      [dropdownWidth]="380"
      [overlayPosition]="overlayPosition"
      [dropdownMaxHeight]="filterColumnsContainerHeight"
    >
      <div class="center">
        <app-hoverable-svg [icon]="icons.Tune" class="svg24 dark-gray-color"></app-hoverable-svg>
      </div>
    </app-multi-select>
  }

  <button class="mobile-modal btn-empty filter-modal" (click)="openModal()">
    <app-hoverable-svg [icon]="icons.Tune" class="svg24 dark-gray-color"></app-hoverable-svg>
  </button>
}

<ng-template #filterTemp>
  <div class="container">
    <div class="title">
      <span class="h3">{{ 'DATA.COLUMNS_SELECTION' | translate }}</span>
      <button class="btn-empty" (click)="closeModal()">
        <svg [icon]="icons.Close" class="dark-gray-color svg24 close-icon" />
      </button>
    </div>

    <!-- <div class="title mt16 mb16">
      <app-search-input (searchTextChange)="searchStart($event)" [hideGlobalSearchLink]="true"></app-search-input>
    </div> -->

    <div class="column-list">
      <mat-checkbox [checked]="isPinned" (change)="pinColumn($event.checked)" class="pin-column">
        Закрепить первый столбец
      </mat-checkbox>
      <mat-checkbox [checked]="isAllSelected$ | async" (change)="toggleAll($event.checked)">
        {{ 'SHARED_COMPONENTS.SELECT_ALL' | translate }}
      </mat-checkbox>
      <div class="horizontal-line"></div>
      <div class="columns-wrapper">
        <div class="">
          @for (column of selectColumns; track column) {
            <mat-checkbox [checked]="column.isSelected" (change)="toggleColumn(column)">
              <span>{{column.title || ''}}</span>
            </mat-checkbox>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
